export function verifyBrowserSupport() {
    window.WebSocket = window.WebSocket || window.MozWebSocket;
    const webrtcIsSupported = Boolean(navigator.webkitGetUserMedia || navigator.mozGetUserMedia || window.RTCPeerConnection);
    if (!window.WebSocket || !webrtcIsSupported) {
        throw new Error('Browser not supported');
    }
}
//# sourceMappingURL=utils.js.map